import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funkprotokoll-meldeart-aktualisieren';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollMeldeartAktualisierenEffects {

    FunkprotokollMeldeartAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKPROTOKOLL_MELDEART_AKTUALISIEREN),
        mergeMap((x: ac.PostFunkprotokollMeldeartAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunkprotokollMeldeartAktualisieren(x.funkprotokollMeldeartDatenRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunkprotokollMeldeartAktualisierenErfolgreichAction(result, x.funkprotokollMeldeartDatenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunkprotokollMeldeartAktualisierenFehlerAction(error, x.funkprotokollMeldeartDatenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollCommandService);
        }
        return this.service;
    }
}
